module.exports = function(){


    if ( $('[js-form-eph-join-our-team]').length ) {
        $('[js-form-eph-join-our-team]').parsley();
    }



    $(document).on('change', '[js-linkedin-url-input]', function(event) {
        event.preventDefault();
        var val = $(this).val();

        var prefix = 'https://';
        if ( (val != '') && val.substr(0, prefix.length) !== prefix){
            $(this).val(prefix + val );
        }

    });


    $('[js-form-eph-join-our-team]').on('submit', function(event) {

        event.preventDefault();

        var $form = $(this),
            $formResponse = $('.js-form-response'), $data = $('[js-form-eph-join-our-team]').serialize();

        if ( !$form.parsley().isValid() ) {
            return false;
        }

        $form.find('button[type="submit"]').text('Sending...');

        $form.find('input, button, textarea').prop('disabled', true);

        $.ajax({
            url: '/wp-admin/admin-ajax.php',
            type: 'POST',
            dataType: 'json',
            data: 'action=eph_join_our_team&' + $data,
            error: function(jqXHR, textStatus, errorThrown) {
                console.log('Error: ' + textStatus);

                $form.find('input, button, textarea').removeProp('disabled').removeAttr('disabled');
                $form.find('button[type="submit"]').text('Join Today');

                window.alertify.error('An error has occurred while submitting your request! Please try again later.')
            },
            success: function(data) {

                if (data.type === 'success') {
                    $form.find('button[type="submit"]').text('Message sent successfully.');
                    $form.find($formResponse).text('Application received. Congratulations! You’re well on your way to earning money by spreading your own personal style to your network, in your city, on your schedule. Our Sales Manager will be in touch to discuss your application within 2-3 business days. If you have any further questions, please contact support@ephapparel.com.');
                    $form.find($formResponse).addClass('is-visible is-success');
                } else {
                    $form.find('input, button, textarea').removeProp('disabled').removeAttr('disabled');
                    $form.find('button[type="submit"]').text('Join Today');

                    if (!!data.text) {
                        window.alertify.error(data.text)
                    } else {
                        window.alertify.error('An error has occurred! Please try again later.')
                    }
                }

                console.log($data, data)
            }
        })

    });




}; // end of module.exports



// WEBPACK FOOTER //
// ./js-source/integration/form-join-our-team.js